import type { GlyphName } from '../components/glyphs/Glyph';

export type LevelArt = { glyph?: GlyphName; critter?: string };

// Fifteen levels; each one is a bridge on the progress trail.
export const LEVELS: { level: number; minDiamonds: number; reward: string; label: string; art: LevelArt }[] = [
    { level: 1, minDiamonds: 0, reward: 'התחלה', label: 'טירון', art: { glyph: 'sprout' } },
    { level: 2, minDiamonds: 500, reward: 'אווטאר רובוט', label: 'מתחיל', art: { critter: 'avatar_robot' } },
    { level: 3, minDiamonds: 1000, reward: 'משחק מילים', label: 'מתקדם', art: { glyph: 'game' } },
    { level: 4, minDiamonds: 1500, reward: 'ערכת לילה', label: 'חכם', art: { glyph: 'sleepy' } },
    { level: 5, minDiamonds: 2000, reward: 'אווטאר נינג\'ה', label: 'מקצוען', art: { critter: 'avatar_ninja' } },
    { level: 6, minDiamonds: 2500, reward: 'משחק חשבון', label: 'אלוף', art: { glyph: 'game' } },
    { level: 7, minDiamonds: 3000, reward: 'קופסת הפתעה', label: 'מאסטר', art: { glyph: 'gift' } },
    { level: 8, minDiamonds: 3500, reward: 'אווטאר כתר', label: 'גורו', art: { critter: 'avatar_king' } },
    { level: 9, minDiamonds: 4000, reward: 'פרס גדול', label: 'אגדה', art: { glyph: 'gift' } },
    { level: 10, minDiamonds: 4500, reward: 'כתר זהב', label: 'טיטאן', art: { glyph: 'crown' } },
    { level: 11, minDiamonds: 5000, reward: 'תיבת אוצר', label: 'עילוי', art: { glyph: 'bag' } },
    { level: 12, minDiamonds: 5500, reward: 'אווטאר מלכותי', label: 'קיסר', art: { critter: 'avatar_queen' } },
    { level: 13, minDiamonds: 6000, reward: 'סקין יהלום', label: 'מיתולוגיה', art: { glyph: 'diamond' } },
    { level: 14, minDiamonds: 6500, reward: 'גביע הניצחון', label: 'אלמותי', art: { glyph: 'star' } },
    { level: 15, minDiamonds: 7000, reward: 'היכל התהילה', label: 'אל', art: { glyph: 'flag' } },
];
